import { render, staticRenderFns } from "./detailComFinInfo.vue?vue&type=template&id=116cc6a7&scoped=true&"
import script from "./detailComFinInfo.vue?vue&type=script&lang=js&"
export * from "./detailComFinInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailComFinInfo.vue?vue&type=style&index=0&id=116cc6a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116cc6a7",
  null
  
)

export default component.exports